import { AnimatedEllipsis } from '@/components/chat/AnimatedEllipsis';

export function AssistantLoading() {
  return (
    <div className="flex justify-start p-1">
      <div className="flex items-center gap-2 px-4 py-3">
        <AnimatedEllipsis color="synergy-neutral" size="sm" />
      </div>
    </div>
  );
}
